export default __webpack_public_path__ + "741b54a4a6d289ce317b8759b953e85f.jpg";